<template>
    <div>
        <div v-if="isDisabled" class="form-error-msg">
            <span class="error">* You need to review the mandatory fields before you can save.</span>
        </div>

        <div class="d-flex justify-content-end align-items-center my-1 py-2" v-if="showButtons">
            <button class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <button class="btn cancel wider mr-3" @click="back">Back</button>

            <button v-if="showExistingAgentSelector" class="btn green wider mr-3" :disabled="isDisabled" @click="save()">Send</button>
            <button v-else-if="!form.saveAndSend" class="btn green wider mr-3" :disabled="isDisabled" @click="save()">Save</button>
            <button v-else-if="form.saveAndSend" class="btn green wider" :disabled="isDisabled" @click="save()">Invite</button>
        </div>

        <div class="micro-tabs-content mt-0">
            <div v-if="activeTab === 0">
                <!-- Show payment protocol -->
                <div>
                    <div class="form-group row">
                        <div v-if="payments" class="col-sm-12">
                            <h5>Payment Protocol</h5>
                            <label class="full">Amount received by the agent</label>

                            <v-select
                                :disabled="disableInputs"
                                v-model="selectedPayment"
                                :options="payments"
                                label="description"
                                placeholder="- Select payment -"
                                @input="updatePayment">
                            </v-select>
                        </div>
                    </div>

                    <div v-if="payments && form.payment == 2" class="form-group row">
                        <div v-if="deposits" class="col-sm-8">
                            <label class="full">Deposit</label>

                            <v-select
                                :disabled="disableInputs"
                                v-model="selectedDeposit"
                                :options="deposits"
                                label="description"
                                placeholder="- Select deposit -"
                                @input="updateDeposit">
                            </v-select>

                            <div class="fs-smaller mt-2 dark">
                                This is the deposit that the customer must pay at the time of booking.
                            </div>
                        </div>

                        <div v-if="showDepositValue" class="col-sm-4">
                            <label class="full">
                                &nbsp;

                                <div class="d-flex">
                                    <input class="glued-right" type="number" v-model.number="form.depositValue">
                                    <div class="glued-left glued-left-min-width">{{ selectedDeposit.symbol }}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="loadingCommissions" class="text-center p-4">
                    <loader></loader>
                </div>

                <div class="text-center p-4 dark font-weight-600 fs-large" v-if="!loadingCommissions && form.commission.commissionRelations.length == 0">
                    You have no products on your account
                </div>

                <div v-else>
                    <table v-if="form.commission && !loadingCommissions" class="table shaded commissions fs-normal">
                        <thead>
                            <th></th>
                            <th class="value text-center" style="width: 100px;">Product</th>
                            <th class="value text-center" style="width: 100px;">Extras</th>
                        </thead>
                        <tbody>
                            <tr class="hidden">
                                <td>Standard commission (%)</td>
                                <td>
                                    <input type="number" :disabled="disableInputs" v-model="form.commission.productAmountValue">
                                </td>
                            </tr>

                            <tr v-for="commission in form.commission.commissionRelations">
                                <td>{{ commission.productName }}</td>
                                <td class="value" style="width: 80px;">
                                    <div class="d-flex" style="width: 115px;">
                                        <input type="number" :disabled="disableInputs" class="glued-right" style="width: 65px;" v-model="commission.productAmountValue">
                                        <v-select class="glued-left" style="width: 50px;" :disabled="disableInputs" v-model="commission.productAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged($event, commission, 'productAmountType')"></v-select>
                                    </div>
                                </td>
                                <td class="value" style="width: 80px;">
                                    <div class="d-flex" style="width: 115px;">
                                        <input type="number" :disabled="disableInputs" class="glued-right" style="width: 65px;" v-model="commission.componentAmountValue">
                                        <v-select class="glued-left" style="width: 50px;" :disabled="disableInputs" v-model="commission.componentAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged($event, commission, 'componentAmountType')"></v-select>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-else-if="activeTab === 1">
                This information is not available yet.
            </div>

            <div v-else>
                This information is not available yet.
            </div>
        </div>

        <div class="d-flex justify-content-end align-items-center my-1 py-2" v-if="showButtons">
            <button class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <button class="btn cancel wider mr-3" @click="back">Back</button>
            <button v-if="showExistingAgentSelector" class="btn green wider mr-3" :disabled="isDisabled" @click="save()">Send</button>
            <button v-else-if="!form.saveAndSend" class="btn green wider mr-3" :disabled="isDisabled" @click="save()">Save</button>
            <button v-else-if="form.saveAndSend" class="btn green wider" :disabled="isDisabled" @click="save()">Invite</button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Loader from '@/tools/loaders/loader1'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data() {
            return {
                form: {},
                activeTab: 0,
                tabs: ['Products', 'Extras', 'Transports'],
                loadingCommissions: false,
                selectedPayment: null,
                selectedDeposit: null,
            }
        },
        props: {
            showButtons: {
                default: true
            },
            selectedAgent: {
                default: null
            },
            showExistingAgentSelector: {
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
        },
        created() {
            if (this.selectedAgent) {
                this.form = this.selectedAgent;
                this.getAgentCommissions();
            } else if (this.getSelectedPerson) {
                this.form = this.getSelectedPerson;
                this.getAgentCommissions();
                this.agentId = this.getSelectedPerson.id;
            } else if (this.getClonedAgent.name) {
                this.form = JSON.parse(JSON.stringify(this.getClonedAgent));
                this.getAgentCommissions();
            }

            if (!this.form) {
                this.$router.push({ name: 'agents' });
            }

            // Set correct deposit
            this.setCorrectDeposit();
            this.updateDeposit();
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getClonedAgent',
                'getProducts',
                'account',
                'getPercentageOrCurrency',
                'getDepositOptions',
                'getRequirePaymentOptions',
                'getCompanySettings'
            ]),
            disableInputs() {
                return false;
            },
            payments() {
                return this.getRequirePaymentOptions;
            },
            deposits() {
                return this.getDepositOptions;
            },
            showDepositValue() {
                return this.selectedDeposit && this.selectedDeposit.id != 2;
            },
            agent() {
                if (this.getSelectedPerson) {
                    return this.getSelectedPerson;
                }
                else if (this.getClonedAgent) {
                    return this.getClonedAgent;
                }

                return null;
            },
            companySettings() {
                return this.getCompanySettings;
            }
        },
        methods: {
            ...mapActions([
                'updateClonedAgent',
                'updateNewAgentSetup'
            ]),
            setCorrectDeposit() {
                const isEdit = this.form.hasOwnProperty('id');

                const depositType = isEdit ? this.form.depositType : this.companySettings.settingsPresets.agentsDepositType;
                const paymentType = isEdit ? this.form.payment : this.companySettings.settingsPresets.agentsPaymentDepositType;
                
                this.form.depositType = depositType;
                this.form.payment = paymentType;

                this.selectedDeposit = this.getDepositOptions.find(option => option.id == depositType);
                this.selectedPayment = this.getRequirePaymentOptions.find(option => option.id == paymentType);
                
                this.form.depositValue = isEdit ? this.form.depositValue : this.companySettings.settingsPresets.agentsDepositValue;
            },
            getAgentCommissions() {
                if (!this.form.commission || this.form.commission.commissionRelations.length == 0) {
                    this.loadingCommissions = true;
                    let serviceString = '/api/people/GetAgentCommissions';

                    if (this.agent.isOTA) {
                        serviceString = '/api/people/GetChannelCommissions';
                    }

                    let params = {
                        supplierId: this.account.supplierId,
                        agentId: this.agent.id
                    }

                    // If it is a OTA (third party agent platform like "getYourGuide")
                    if (this.form.isOTA) {
                        serviceString = '/api/people/GetChannelCommissions';

                        params = {
                            supplierId: this.account.supplierId,
                            channelId: this.agent.id
                        }
                    }

                    axios.get(serviceString, {
                        params: params
                    }).then(response => {
                        this.loadingCommissions = false
                        if (response && response.status === 200 && response.data) {
                            // If creating a new agent, this will return commissionRelations with agentId = 0 | This sets it as null

                            response.data.commissionRelations.map(commissionRelation => {
                                commissionRelation.agentId = (commissionRelation.agentId == 0)? null : commissionRelation.agentId;
                                commissionRelation.id = (commissionRelation.id == 0)? null : commissionRelation.id;
                            })

                            this.$set(this.form, 'commission', response.data);
                            this.addValueTypeHelper();
                        }
                    })
                }
            },
            getOtaCommissions() {
                if (!this.form.commission || this.form.commission.commissionRelations.length == 0) {
                    this.loadingCommissions = true;
                    axios.get('/api/people/GetChannelCommissions', {
                        params: {
                            supplierId: this.account.supplierId,
                            agentId: this.agent.id
                        }
                    }).then(response => {
                        this.loadingCommissions = false;
                        if (response && response.status === 200 && response.data) {
                            // If creating a new agent, this will return commissionRelations with agentId = 0 | This sets it as null
                            response.data.commissionRelations.map(commissionRelation => {
                                commissionRelation.agentId = (commissionRelation.agentId == 0)? null : commissionRelation.agentId;
                                commissionRelation.id = (commissionRelation.id == 0)? null : commissionRelation.id;
                            })

                            this.$set(this.form, 'commission', response.data);
                            this.addValueTypeHelper();
                        }
                    })
                }
            },
            updateDeposit() {
                if (!this.selectedDeposit || this.selectedDeposit.id === undefined) {
                    return;
                }

                this.$set(this.selectedDeposit, 'symbol', (this.selectedDeposit.id === 0) ? '€' : '%');
                this.$set(this.form, 'deposit', this.selectedDeposit.id);
                this.$set(this.form, 'depositType', this.selectedDeposit.id);
            },
            addValueTypeHelper() {
                this.form.commission.commissionRelations.map(commissionRow => {
                    // Sets Type helper
                    this.$set(commissionRow, 'productAmountType_helper_selected', this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return commissionRow.productAmountType == percentageOrCurrency.id;
                    })[0]);

                    this.$set(commissionRow, 'componentAmountType_helper_selected', this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return commissionRow.componentAmountType == percentageOrCurrency.id;
                    })[0]);

                    this.$set(commissionRow, 'transportAmountType_helper_selected', this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return commissionRow.transportAmountType == percentageOrCurrency.id;
                    })[0]);
                });
            },
            formatValue() {
                if (this.form.paymentValue !== undefined) {
                    this.form.depositValue = parseFloat(this.form.paymentValue).toFixed(2);
                }
            },
            updatePayment() {
                this.form.payment = this.selectedPayment.id;
                if (this.selectedPayment === this.payments[0]) {
                    this.form.paymentValue = 0;
                }

                this.formatValue();
            },
            commissionTypeChanged(selectedOption, commission, type) {
                commission[type] = selectedOption.id;
            },
            toggleTab(event, key) {
                this.activeTab = key;
            },
            cancel() {
                this.$emit('cancel');
            },
            back() {
                // In case there is an error it has data to populate the new agent form
                this.updateNewAgentSetup(this.form); 
                this.updateClonedAgent(this.form);
                this.$emit('back');
            },
            save() {
                // In case there is an error it has data to populate the new agent form
                this.updateNewAgentSetup(this.form);
                this.updateClonedAgent(this.form);
                this.$emit('save');
            }
        },
        components: {
            Loader,
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
    .commissions {
        td:nth-child(2) {
            width: 20%;

            > input {
                width: 5rem;
            }
        }
    }

    .glued-left-min-width {
        min-width: 2.25rem;
    }

    .form-error-msg {
        margin-bottom: -1.565rem;
    }
</style>



// WEBPACK FOOTER //
// AgentCommissions.vue?d2d4abbe